/* Standard PDP: existing Shopify media, room preview and full-size following gallery. */
(function () {
 'use strict';
 var root=document.querySelector('.ef-standard-product-schema');
 if(!root)return;
 var gallery=root.querySelector('.efx-pdp__gallery'),main=root.querySelector('#efGallerySwiper');
 if(!gallery||!main)return;
 function positionGallery(){
  var header=document.querySelector('#efx-header');
  var headerBottom=header?Math.max(0,header.getBoundingClientRect().bottom):80;
  // Negative top lets a tall gallery scroll to its lower controls before sticking.
  var top=Math.min(headerBottom+16,innerHeight-100-gallery.getBoundingClientRect().height);
  gallery.style.setProperty('--ef-standard-gallery-top',Math.round(top)+'px');
 }
 var queued=false;
 function queuePosition(){if(queued)return;queued=true;requestAnimationFrame(function(){queued=false;positionGallery();});}
 if(window.ResizeObserver){var ro=new ResizeObserver(queuePosition);ro.observe(gallery);var header=document.querySelector('#efx-header');if(header)ro.observe(header);}
 addEventListener('resize',queuePosition);addEventListener('scroll',queuePosition,{passive:true});positionGallery();
 var model=main.querySelector('model-viewer');
 if(!model)return;
 function activeModel(){return main.querySelector('.swiper-slide-active model-viewer')||model;}
 var modelSlide=model.closest('.swiper-slide'),modelThumb=root.querySelector('.ef-pd-thumb--3d');
 var viewButton=root.querySelector('[data-ef-standard-3d]'),roomButton=root.querySelector('[data-ef-standard-room]');
 var note=document.createElement('p');note.className='ef-standard-model-note';note.hidden=true;
 note.textContent='3D shows the product style. Refer to the photos for finish and your selected size for dimensions.';
 gallery.appendChild(note);
 var revealTimer=0,revealAttempts=0;
 function revealModel(){
  clearTimeout(revealTimer);
  if(!main.swiper){
   note.hidden=false;note.textContent='Loading 3D preview…';
   if(revealAttempts++<60)revealTimer=setTimeout(revealModel,100);
   else{revealAttempts=0;note.textContent='The 3D preview could not start. Please try again.';}
   return;
  }
  revealAttempts=0;
  note.textContent='3D shows the product style. Refer to the photos for finish and your selected size for dimensions.';
  var index=Array.prototype.indexOf.call(modelSlide.parentElement.children,modelSlide);
  if(main.swiper)main.swiper.slideTo(index);
  model.setAttribute('reveal','auto');
  if(typeof model.dismissPoster==='function')model.dismissPoster();
  note.hidden=false;
  var oldPosition=gallery.style.getPropertyValue('position'),oldPriority=gallery.style.getPropertyPriority('position');
  gallery.style.setProperty('position','static','important');
  var top=main.getBoundingClientRect().top+scrollY;
  if(oldPosition)gallery.style.setProperty('position',oldPosition,oldPriority);else gallery.style.removeProperty('position');
  var h=document.querySelector('#efx-header');
  window.scrollTo({top:Math.max(0,top-(h?h.getBoundingClientRect().height:80)-16),behavior:'instant'});
 }
 function syncModel(){note.hidden=!modelSlide.classList.contains('swiper-slide-active');}
 new MutationObserver(syncModel).observe(modelSlide,{attributes:true,attributeFilter:['class']});
 if(viewButton)viewButton.addEventListener('click',revealModel);
 if(modelThumb){modelThumb.addEventListener('click',function(){model.setAttribute('reveal','auto');if(typeof model.dismissPoster==='function')model.dismissPoster();});modelThumb.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();revealModel();}});}
 var dialog,opener,oldOverflow;
 function createDialog(){
  if(dialog)return;
  dialog=document.createElement('dialog');dialog.id='efStandardRoom';dialog.setAttribute('aria-labelledby','efStandardRoomTitle');
  dialog.innerHTML='<button type="button" data-room-close aria-label="Close room preview">×</button><h2 id="efStandardRoomTitle">Preview in your room</h2><p data-room-status>Scan the QR code with your phone. Once the product page opens, tap “View in AR” to see it in your room.</p><img data-room-qr width="200" height="200" alt="Scan to open this product on your phone"><a data-room-link>Open product page</a><button type="button" data-room-start hidden>View in AR</button><button type="button" data-room-model>View in 3D instead</button>';
  document.body.appendChild(dialog);
  dialog.querySelector('[data-room-close]').addEventListener('click',function(){dialog.close();});
  dialog.querySelector('[data-room-model]').addEventListener('click',function(){dialog.close();revealModel();});
  dialog.querySelector('[data-room-start]').addEventListener('click',function(){dialog.close();roomButton.click();});
  function updateAR(){dialog.querySelector('[data-room-start]').hidden=!activeModel().canActivateAR;}
  model.addEventListener('load',updateAR);customElements.whenDefined('model-viewer').then(updateAR);updateAR();
  dialog.addEventListener('click',function(e){if(e.target!==dialog)return;var r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();});
  dialog.addEventListener('close',function(){document.documentElement.style.overflow=oldOverflow;if(opener&&opener.isConnected)opener.focus({preventScroll:true});});
 }
 function showRoom(message){
  createDialog();if(dialog.open)return;
  dialog.querySelector('[data-room-start]').hidden=!activeModel().canActivateAR;
  var url=new URL(location.href);url.searchParams.set('ar','true');
  var variant=root.querySelector('#efUniVariantId');if(variant&&variant.value)url.searchParams.set('variant',variant.value);
  dialog.querySelector('[data-room-qr]').src='https://api.qrserver.com/v1/create-qr-code/?size=200x200&data='+encodeURIComponent(url.href);
  var link=dialog.querySelector('[data-room-link]');link.href=url.href;
  dialog.querySelector('[data-room-status]').textContent=message||'Scan the QR code with your phone. Once the product page opens, tap “View in AR” to see it in your room.';
  opener=document.activeElement;oldOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';dialog.showModal();
 }
 if(roomButton)roomButton.addEventListener('click',function(){
  var selectedModel=activeModel();
  if(selectedModel.canActivateAR&&typeof selectedModel.activateAR==='function'){
   try{var result=selectedModel.activateAR();if(result&&result.catch)result.catch(function(){showRoom('Room preview could not start. Try an AR-compatible phone, or view the model in 3D.');});}catch(e){showRoom('Room preview could not start. Try an AR-compatible phone, or view the model in 3D.');}
  }else showRoom();
 });
 if(new URL(location.href).searchParams.get('ar')==='true')showRoom('Tap “View in AR” to see this product in your room on a compatible phone.');
})();
